import { api } from '@/services/api/main/axios';

export const getCustomColumnsApiRequest = async (): Promise<unknown[]> => {
  const res = await api.get<{ payload: unknown[] }>('custom-columns');
  return res.data.payload;
};

export const postCustomColumnApiRequest = async (payload: object): Promise<unknown> => {
  const res = await api.post<{ payload: unknown }>('custom-columns', payload);
  return res.data.payload;
};

export const putCustomColumnApiRequest = async (payload: { id: string } & Record<string, unknown>): Promise<unknown> => {
  const res = await api.put<{ payload: unknown }>(`custom-columns/${payload.id}`, payload);
  return res.data.payload;
};

export const deleteCustomColumnApiRequest = async (id: string): Promise<void> => {
  await api.delete(`custom-columns/${id}`);
};
